var React = require('react');

function ArrowTopRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L11 1L11 11","stroke":"white","strokeWidth":"1.6","key":0}),React.createElement("path",{"d":"M11 1L1 11","stroke":"white","strokeWidth":"1.6","key":1})]);
}

ArrowTopRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowTopRight;

ArrowTopRight.default = ArrowTopRight;
